<script>
    const investorList = [
        {
            title: 'VcX',
            description: 'Where new generations of entrepreneurial families around the world build'+
            'and network with top Silicon Valley VCs and founders leading the future.',
            page: 'program_vcx',
        },
        {
            title: 'Invest with us',
            description: 'We invest in founders building the future. If you want to get involved'+
            ' with pre-seed to pre-series A companies, join our investor network!',
            page: 'program_invest',
        },
    ];
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<div class="container-fluid desktop">
    <div class="row">
        <div class="col-md-12 col-xl-12 ">
            <div class="form_adjust">
                <div class="main shadow mx-5">
                    <hr style="border: 0.066vw solid rgb(226, 242, 255); background: rgb(226, 242, 255); opacity: 0.6;"/>
                    <div style=" display: flex; flex-direction: row; gap:3.558vw;">
                        {#each  investorList as data, index}
                            <div
                                class="content-background"
                                on:click={() => (location.href = data.page)}
                            >
                            <div style="padding-left: 1vw; padding-right: 1vw;">
                                <div style="display: flex; flex-direction:row; gap:1.316vw; margin-top: 1.2vw;">
                                    <div style="width: 0.402vw; height:1.359vw; color:#00204B">
                                        <h6 class="num">{index + 1}-</h6>
                                    </div>
                                    <div>
                                        <h3 class="h3">{data.title}</h3>
                                    </div>
                                </div>
                                <div style="width:16.7vw; font-size:1.062vw; padding-left: 1.7vw; margin-bottom: 2.966vw; margin-bottom: 1.859vw;">
                                    <p class="font-color">{data. description}</p>
                                </div>
                            </div>
                            </div>                        
                        {/each}
                    </div>
                    <hr style="border: 0.066vw solid rgb(226, 242, 255); background: rgb(226, 242, 255); opacity: 0.6;"/>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mobile-version">
    <div class="main-div">
        <div class="major">
            <div class="part-1">
                <div
                    style="width: 50vw; padding-left:3vw; padding-top: 5vw; border-right:0.234vw solid rgba(196, 196, 196, 1);"
                >
                    <div class="block1">
                        <div
                            class="d-flex align-items-baseline justify-content-between"
                        >
                            <div class="">
                                <h6 class="number">1-</h6>
                            </div>
                            <div style=" width: 39vw;">
                                <p class="title">
                                    Fundamentals of Entrepreneurship
                                </p>

                                <p class="text" style="margin-top: 9vw;">
                                    Small Description of the course with the
                                    mentioning of main key take..
                                </p>
                                <p class="title2">2 weeks - Virtual</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style="width: 50vw;  padding-left:3vw; padding-top: 5vw; padding-bottom: 5vw;"
                >
                    <div class="block2">
                        <div
                            class="d-flex align-items-baseline justify-content-between"
                        >
                            <div class="">
                                <h6 class="number">2-</h6>
                            </div>
                            <div style=" padding-top: 3vw; width:39vw;">
                                <p class="title">Hero Training</p>

                                <p class="text" style="margin-top: 11vw; ">
                                    Small Description of the course with the
                                    mentioning of main key take..
                                </p>
                                <p class="title2">1 month - on Campus</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-1">
                <div
                    style="width: 50vw; padding-left:3vw; border-right:0.234vw solid rgba(196, 196, 196, 1); padding-top: 5vw; padding-bottom: 5vw;"
                >
                    <div class="block1">
                        <div
                            class="d-flex align-items-baseline justify-content-between"
                        >
                            <div class="">
                                <h6 class="number">3-</h6>
                            </div>
                            <div style=" width: 39vw;">
                                <p class="title">VeChain EDX</p>
                                <p class="text" style="margin-top: 11vw;">
                                    Small Description of the course with the
                                    mentioning of main key take..
                                </p>
                                <p class="title2">2 weeks - Virtual</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style="width: 50vw;  padding-left:3vw; padding-top: 5vw; padding-bottom: 5vw;"
                >
                    <div class="block2">
                        <div
                            class="d-flex align-items-baseline justify-content-between"
                        >
                            <div class="">
                                <h6 class="number">4-</h6>
                            </div>
                            <div style=" width:39vw;">
                                <p class="title">edx Program</p>

                                <p class="text" style="margin-top: 11vw;">
                                    Small Description of the course with the
                                    mentioning of main key take..
                                </p>
                                <p class="title2">2 weeks - Virtual</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="major-2">
            <div class="input">
                <p class="head1">Accelerators</p>
                <input
                    class="placeholder"
                    type="text"
                    placeholder="Text here, which helps user to navigate and tell them where this option will lead to."
                />
            </div>
            <div class="input">
                <p class="head1">Mentors</p>
                <input
                    class="placeholder"
                    type="text"
                    placeholder="Text here, which helps user to navigate and tell them where this option will lead to."
                />
            </div>
            <div class="input">
                <p class="head1">Community</p>
                <input
                    class="placeholder"
                    type="text"
                    placeholder="Text here, which helps user to navigate and tell them where this option will lead to."
                />
            </div>
        </div>
    </div>
</div>

<style>
    @media screen and (max-width: 1024px) {
        .main-div {
            position: fixed;
            z-index: 2;
            width: 100vw;
            background-color: white;
            top: 18vw;
            padding: 7vw 0;
        }
        .number {
            font-size: 4.673vw;
        }

        .input {
            margin-top: 5vw;
            margin-left: 3vw;
        }
        .head1 {
            font-family: "Inter";
            font-style: normal;
            font-weight: 500;
            font-size: 3.505vw;
            line-height: 4.206vw;
            color: #00204b;
        }
        .placeholder {
            background-color: white;
            width: 95.327vw;
            border-right: none;
            border-left: none;
            border-bottom: 1px solid;
            border-top: none;
            border-color: #00204b;
            margin-bottom: 6vw;
            font-family: "Inter";
            font-style: normal;
            font-weight: 300;
            font-size: 2.336vw;
            line-height: 2.804vw;

            color: rgba(0, 32, 75, 0.6);
        }
        .major-2 {
            display: block !important;
            padding-bottom: 8vw;
        }
        .major {
            display: block;
        }

        .title {
            width: 42.757vw;
            font-family: "Manrope";
            font-style: normal;
            font-weight: 500;
            font-size: 4.673vw;
            line-height: 4.673vw;
            color: #00204b;
        }
        .text {
            font-family: "Inter";
            font-style: normal;
            font-weight: 300;
            font-size: 2.336vw;
            line-height: 2.804vw;
            color: rgba(0, 32, 75, 0.6);
            height: 8.411vw;
            margin-top: 5vw;
        }
        .title2 {
            width: 27.472vw;
            font-style: normal;
            font-weight: 500;
            font-size: 2.57vw;
            line-height: 3.037vw;

            color: #00204b;
        }
        .part-1 {
            display: flex;
            margin-top: 8vw;
            width: 94vw;
        }

        .mobile-version {
            display: block !important;
        }
        .desktop {
            display: none;
        }
    }

    .mobile-version {
        display: none;
    }
    .form_adjust {
        top: 6.027vw;
        width: 80vw;
        margin: auto;
        position: absolute;
        left: 10vw;
    }
    .num {
        font-size: 1.328vw;
        padding-top: 0.1vw;
    }
    hr {
        border: 0.052083vw solid rgba(0, 32, 75, 1);
    }
    .font-color {
        color: #00204b99;
        font-size: 12;
    }
    .h3 {
        font-family: Manrope;
        font-size: 1.328vw;
        font-weight: 500;
        line-height: 1.770834vw;
        text-align: left;
        width: 12.1875vw;
        padding-bottom: 0.5vw;
        height: 4vw;
        color: #00204B;
    }
    .main {
        padding: 3vw 5.179vw;
        background-color: white;
        border-radius: 0.664vw;
    }
    .content-background:hover{
        background-color: #E2F2FF; 
        cursor: pointer; 
        border-radius: 0.8vw;
    }
</style>
